export default __webpack_public_path__ + "static/Entenda0013-62db27f1afe89f604e818645a625e64f.jpg";